import { render, staticRenderFns } from "./GoodsList.vue?vue&type=template&id=dfb226ea&scoped=true"
import script from "./GoodsList.vue?vue&type=script&lang=js"
export * from "./GoodsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb226ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfb226ea')) {
      api.createRecord('dfb226ea', component.options)
    } else {
      api.reload('dfb226ea', component.options)
    }
    module.hot.accept("./GoodsList.vue?vue&type=template&id=dfb226ea&scoped=true", function () {
      api.rerender('dfb226ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/goods/GoodsList.vue"
export default component.exports